import { render, staticRenderFns } from "./kangfu.vue?vue&type=template&id=d917cfec"
import script from "./kangfu.vue?vue&type=script&lang=js"
export * from "./kangfu.vue?vue&type=script&lang=js"
import style0 from "./kangfu.vue?vue&type=style&index=0&id=d917cfec&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports